import { useCallback } from 'react'
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
} from '@mui/material'

interface DropdownProps extends SelectProps {
  title: string
  value: string
  options: Array<{ value: string | number; name: string }>
  handleChange: (value: string) => void
  withFullWidth?: boolean
  className?: string
}

const Dropdown = ({
  title,
  value,
  options,
  handleChange,
  withFullWidth,
  className,
  ...rest
}: DropdownProps): JSX.Element => {
  const getId = useCallback(
    () => title.toLowerCase().replaceAll(' ', '-'),
    [title]
  )

  return (
    <FormControl fullWidth={withFullWidth} className={className}>
      <InputLabel id={`${getId()}-label`}>{title}</InputLabel>
      <Select
        labelId={`${getId()}-label`}
        id={getId()}
        value={value}
        label={title}
        {...rest}
        onChange={(e) => handleChange(String(e.target.value))}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default Dropdown
